import { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Common } from '@thecvlb/design-system/lib/src';

import { selectOrchestrate } from 'store';

import Loader from 'shared/Loader';
import RadioGroup from 'shared/RadioGroup';

import { useAppSelector, useQuery } from 'hooks';
import useSubmitOrchestrateForm from 'hooks/useSubmitOrchestrateForm';

import Heading from '../../components/Heading';
import AddInsurance from '../AddInsurance';

const ITEMS = [
  {
    label: 'Yes',
    value: 'yes'
  },
  {
    label: 'No',
    value: 'no'
  }
];

const CheckPrescriptionCoverage: React.FC<{ onContinue: () => void }> = ({ onContinue }) => {
  const stepFromQuery = useQuery().get('step') ?? '';
  const step = (
    ['check-medication-coverage', 'initial'].includes(stepFromQuery) ? stepFromQuery : 'initial'
  ) as 'initial' | 'check-medication-coverage';
  const navigate = useNavigate();
  const { send, isLoading } = useSubmitOrchestrateForm();
  const { mif_qa: mifQA } = useAppSelector(selectOrchestrate);
  const answerOnUsageInsuranceForAppointment =
    mifQA.find((qa) => qa.question === 'use_insurance_for_appointment')?.answer ?? '';

  const handleSelect = (v: string) => {
    if (v === 'yes' && answerOnUsageInsuranceForAppointment === 'no') {
      navigate({
        search: '?step=check-medication-coverage'
      });
    } else {
      send('mif_qa', [{ answer: v, question: 'check_insurance_for_prescriptions' }], () => {
        onContinue();
      });
    }
  };

  const content: Record<'initial' | 'check-medication-coverage' | '', JSX.Element> = {
    '': <Loader isVisible />,
    'check-medication-coverage': <AddInsurance onContinue={onContinue} />,
    initial: (
      <>
        <Heading
          category="Plan"
          subtitle="Your plan will cover appointments with your provider and access to the weight loss program. The cost of medication is not included in the LifeMD weight loss program."
          title="Would you like to check if your medical insurance covers GLP-1 prescriptions?"
        />
        <RadioGroup isLoading={isLoading} items={ITEMS} onSelect={handleSelect} />
        <Common.Alert type="info" colorableBackground>
          Your insurance will not be billed by LifeMD
        </Common.Alert>
      </>
    )
  };

  return <div className="flex flex-col gap-6 md:mx-auto md:max-w-[500px]">{content[step]}</div>;
};

export default CheckPrescriptionCoverage;
